// src/components/payfast/OnceOffPaymentPopup.jsx
//
// TEMPORARY BACKWARD-COMPATIBILITY WRAPPER
//
// Once-off learner payments have been retired.
// Any older page that still imports OnceOffPaymentPopup will now show the
// recurring monthly SubscriptionPopup instead of the old 60-day journey offer.
//
// Once all old imports have been removed, this file can be deleted.

import React from "react";
import SubscriptionPopup from "../subscriptions/SubscriptionPopup";

export default function OnceOffPaymentPopup({
  open = true,
  onClose,
  onAccessAlreadyActive,
}) {
  return (
    <SubscriptionPopup
      open={open}
      onClose={onClose}
      title="Continue your Gwin journey"
      message="Subscribe to Gwin monthly to keep progressing through your business finance journey."
      helperText="Your monthly subscription gives you continued journey access, with up to 3 new levels available each week."
      primaryLabel="Subscribe Monthly"
      onCheckAgain={onAccessAlreadyActive}
    />
  );
}
